import { render, staticRenderFns } from "./DepartmentsManager.vue?vue&type=template&id=3f139252"
import script from "./DepartmentsManager.vue?vue&type=script&lang=js"
export * from "./DepartmentsManager.vue?vue&type=script&lang=js"
import style0 from "./DepartmentsManager.vue?vue&type=style&index=0&id=3f139252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports